import { render, staticRenderFns } from "./examInitiate.vue?vue&type=template&id=985d55be&scoped=true&"
import script from "./examInitiate.vue?vue&type=script&lang=js&"
export * from "./examInitiate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "985d55be",
  null
  
)

export default component.exports